'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isSet;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isSet.js
// module id = 818
// module chunks = 0